import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { formatPickRate } from "../format/formatPickRate";
import type { FixOf } from "../model/Fix";
import { AssetList } from "./AssetList";

const LABEL = msg({
  id: "analysis.fix.counter_items",
  message: "Against {enemy}, players on your hero take more often:",
});
const PICK = msg({ id: "analysis.fix.counter_items.pick", message: "{pick} (usually {usual})" });
const WIN = msg({ id: "analysis.fix.counter_items.win", message: "win rate +{delta} pp" });

// Что сильные игроки на герое игрока берут против этого врага чаще обычного.
export const CounterItemsFix = ({ fix }: { fix: FixOf<"counter_items"> }) => {
  const { i18n } = useLingui();
  const findItem = useAssetLookup("items");
  const enemy = useAssetLookup("heroes")(fix.params.against_hero_id);
  return (
    <AssetList
      label={i18n._({ ...LABEL, values: { enemy: enemy.name } })}
      entries={fix.params.items.map((item) => {
        const pick = i18n._({
          ...PICK,
          values: {
            pick: formatPickRate(item.pick_rate, i18n.locale),
            usual: formatPickRate(item.usual_pick_rate, i18n.locale),
          },
        });
        const win =
          item.win_rate_delta === null
            ? ""
            : ` · ${i18n._({
                ...WIN,
                values: {
                  delta: new Intl.NumberFormat(i18n.locale, { maximumFractionDigits: 1 }).format(
                    item.win_rate_delta * 100,
                  ),
                },
              })}`;
        return { asset: findItem(item.item_id), caption: pick + win };
      })}
    />
  );
};
